import apiClient from '../api';

const API_PATH = '/customers';

export const getAllCustomers = () => {
  return apiClient.get(API_PATH);
};

export const getCustomerById = (id) => {
  return apiClient.get(`${API_PATH}/${id}`);
};

export const createCustomer = (customerData) => {
  return apiClient.post(API_PATH, customerData);
};

export const updateCustomer = (id, customerData) => {
  return apiClient.patch(`${API_PATH}/${id}`, customerData);
};

export const deleteCustomer = (id) => {
  return apiClient.delete(`${API_PATH}/${id}`);
}; 